module.exports = __webpack_public_path__ + "img/z2.a64c3030.png";